export function isCompanyAdminMembership(company = {}) {
  const designation = company.degination || company.designation || company.position;
  if (designation === "EMPLOYEE") {
    return false;
  }
  const role = company.role;
  return (
    designation === "COMPANY ADMIN" ||
    designation === "COMPANY SUPER ADMIN" ||
    designation === "COMPANY_SUPER_ADMIN" ||
    role === "ROLE_COMPANY_SUPER_ADMIN"
  );
}

export function isDeptAdminMembership(company = {}) {
  const designation = company.degination || company.designation || company.position;
  if (designation === "EMPLOYEE") {
    return false;
  }
  const role = company.role;
  return (
    designation === "COMPANY_DEPARTMENT_ADMIN" ||
    role === "ROLE_COMPANY_DEPARTMENT_ADMIN"
  );
}

export function getArticleDeptIds(article) {
  if (!article || article.deptLocation == null || article.deptLocation === "") {
    return [];
  }
  const raw = article.deptLocation;
  const ids = [];
  const seen = new Set();
  const add = (value) => {
    const key = String(value == null ? "" : value).trim();
    if (!key || seen.has(key)) {
      return;
    }
    seen.add(key);
    ids.push(key);
  };
  if (Array.isArray(raw)) {
    for (const item of raw) {
      add(item && item.deptLocation != null ? item.deptLocation : item);
    }
    return ids;
  }
  String(raw)
    .split(",")
    .forEach((part) => add(part));
  return ids;
}

export function articleBelongsToDept(article, deptLocationId) {
  if (!article || deptLocationId == null || deptLocationId === "") {
    return false;
  }
  return getArticleDeptIds(article).includes(String(deptLocationId));
}

export function articleAssignedOnlyToDept(article, deptLocationId) {
  if (!article || deptLocationId == null || deptLocationId === "") {
    return false;
  }
  const ids = getArticleDeptIds(article);
  return ids.length === 1 && ids[0] === String(deptLocationId);
}

function getArticleCompanyId(article = {}) {
  if (article.createdBy === "company" && article.createdById) {
    return article.createdById;
  }
  if (article.companyId) {
    return article.companyId;
  }
  if (article.company) {
    return typeof article.company === "object" ? article.company.id : article.company;
  }
  return null;
}

function isInternalCompanyArticle(article, isInternalFlag) {
  if (isInternalFlag) {
    return true;
  }
  return article && (article.articleType === true || article.articleType === 1 || article.articleType === "1");
}

export function canManageCompanyArticle(article, company, { isInternal = false } = {}) {
  if (!article || !company) {
    return false;
  }
  if (article.createdBy === "user") {
    return false;
  }
  const isCompanyAdmin = isCompanyAdminMembership(company);
  const isDeptAdmin = isDeptAdminMembership(company);
  if (!isCompanyAdmin && !isDeptAdmin) {
    return false;
  }
  const articleCompanyId = getArticleCompanyId(article);
  if (articleCompanyId && company.id && String(articleCompanyId) !== String(company.id)) {
    return false;
  }
  if (isCompanyAdmin) {
    return true;
  }
  if (!isInternalCompanyArticle(article, isInternal)) {
    return false;
  }
  const deptId = company.deptLocationId != null ? company.deptLocationId : company.deptLocation;
  if (deptId == null || deptId === "") {
    return false;
  }
  return articleAssignedOnlyToDept(article, deptId);
}
